<div class="container pt-5">
    <div class="row">
        <div class="col-10 col-md-6" style="margin: 0 auto;">
            <div class="card p-5" style="align-items: center;">
                <div><mat-icon style="font-size: 30px;">warning</mat-icon></div>
                <div style="text-align: center;">
                    <div style="font-family: monospace;font-size: 25px;color: rgba(0, 0, 0, 0.87);">Payment Verification Issue</div>
                    <div style="color: rgba(0, 0, 0, 0.87);" class="py-2">
                        We were unable to verify your payment status.
                    </div>
                    <div style="color: rgba(0, 0, 0, 0.6);" class="py-2">
                        If your payment shows as incomplete, please allow up to 15 minutes for it to process and then refresh your screen.
                    </div>
                    <div style="color: rgba(0, 0, 0, 0.7);" class="py-2" style="text-align: left;">
                        <strong>To check if your payment was processed:</strong>
                        <ol style="text-align: left; margin-top: 8px;">
                            <li>Return to your application</li>
                            <li>Look at the "Pay Application Fee" section (refresh the screen to see updated status)</li>
                            <li>If it shows a checkmark and "Completed", your payment was successful</li>
                        </ol>
                    </div>
                    <div style="color: rgba(0, 0, 0, 0.6);" class="py-2">
                        <strong>Please do not delete your application and start a new one</strong>, as this could result in being charged twice.
                    </div>
                    <div class="mt-3" style="color: rgba(0, 0, 0, 0.6); border-top: 1px solid rgba(0, 0, 0, 0.12); padding-top: 16px; overflow-wrap: break-word;">
                        For questions regarding this payment issue please contact support email
                        <a href="mailto:al-support@tylertech.com" aria-label="Email Tyler Technologies support at al-support@tylertech.com">al-support@tylertech.com</a>
                        or toll-free
                        <a href="tel:+18663533468" aria-label="Call Tyler Technologies support toll-free at 1-866-353-3468" style="white-space: nowrap;">1-866-353-3468</a>.
                    </div>
                    <div class="mt-3">
                        <button *ngIf="token" (click)="retryVerification()" class="btn btn-primary me-2">Retry Verification</button>
                        <a routerLink="/app" class="btn btn-secondary">Return to Applications</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
